// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessPickaxeSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.894 3.529c-.364-.23-.23-.777.22-.817 1.759-.154 4.34.04 6.51 1.106a1 1 0 0 1 1.366.046l2.121 2.121a1 1 0 0 1 .068 1.339c1.08 2.087 1.291 4.505 1.135 6.477-.036.465-.624.625-.863.247-1.177-1.865-2.044-3.208-2.855-4.285a1 1 0 0 1-1.02-.242l-.354-.354-12.02 12.02a.5.5 0 0 1-.708 0l-.707-.706a.5.5 0 0 1 0-.708l12.02-12.02-.353-.354a1 1 0 0 1-.247-1.006c-1.084-.81-2.438-1.681-4.313-2.864z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessPickaxeSolid;
